import * as React from "react"

const MessageSmall = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      stroke="#051711"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M7.085 16.334h-.417c-3.333 0-5-.834-5-5V7.167c0-3.333 1.667-5 5-5h6.667c3.333 0 5 1.667 5 5v4.167c0 3.333-1.667 5-5 5h-.417a.845.845 0 0 0-.667.333l-1.25 1.667c-.55.733-1.45.733-2 0l-1.25-1.667c-.133-.183-.441-.333-.666-.333Z"
    />
    <path
      stroke="#051711"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.33 9.667h.008M9.994 9.667h.008M6.662 9.667h.008"
    />
  </svg>
)
export default MessageSmall
